import api from "./axios";

const BASE = "/cash-cod";

export const listPendingDeposits = async (params = {}) => {
  return api.get(`${BASE}/deposits/pending`, { params });
};

export const listApprovedDeposits = async (params = {}) => {
  return api.get(`${BASE}/deposits/approved`, { params });
};

export const listRejectedDeposits = async (params = {}) => {
  return api.get(`${BASE}/deposits/rejected`, { params });
};

export const approveDeposit = async (
  id,
  { bankReferenceNo, ordersCount, amountCollected, amount }
) => {
  return api.put(`${BASE}/deposits/${id}/approve`, {
    bankReferenceNo,
    ordersCount,
    amountCollected,
    amount,
  });
};

export const rejectDeposit = async (id, payload) => {
  return api.put(`${BASE}/deposits/${id}/reject`, payload);
};

export const bulkApproveDeposits = async (ids, { bankReferenceNo }) => {
  return api.post(`${BASE}/deposits/bulk-approve`, { ids, bankReferenceNo });
};

export const exportDeposits = async (params = {}) => {
  return api.get(`${BASE}/deposits/export`, {
    params,
    responseType: "blob",
  });
};

export const downloadDepositReceipt = async (id) => {
  return api.get(`${BASE}/deposits/${id}/receipt`, { responseType: "blob" });
};

export const downloadDepositScreenshot = async (id) => {
  return api.get(`${BASE}/deposits/${id}/app-screenshot`, {
    responseType: "blob",
  });
};

export const listApproverLog = async (params = {}) => {
  return api.get(`${BASE}/approver-log`, { params });
};

export const exportApproverLog = async (params = {}) => {
  return api.get(`${BASE}/approver-log/export`, {
    params,
    responseType: "blob",
  });
};
